import styled from "styled-components";

export const List = styled.ul``;

export const ListItem = styled.li`
  display: inline-block;
  padding: 0 12px;
  position: relative;

  &:not(:last-child):after {
    background-color: #e6e6e6;
    content: "";
    height: 50%;
    position: absolute;
    right: 0;
    top: 25%;
    width: 1px;
  }
`;
